import { FacultyApi, UniversityCenterApi, UniversityCenterDTO } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new UniversityCenterApi(getAuthConfiguration());


export const getUniversities = () => {
    return ApiFactory().apiUniversityCenterGetAllUniversityCentersGet();
}
